const articles = require('./articles')
const api = require('./api')
const install = require('./install')
const track = require('./track')
const log = require('log').create('beacon') // eslint-disable-line

const Beacon = {
    articles,
    api,
    install,
    track,
    isInstalled() {
        return !! window.Beacon
    },
}

module.exports = Beacon
